import TCBookedLegUIModel from './tc-booked-leg';

class TCBookedLegsCollectionUIModel {
  constructor(legs = []) {
    this.legs = legs.map(leg => {
      return new TCBookedLegUIModel(leg);
    });
  }
}

export default TCBookedLegsCollectionUIModel;